import _ from 'lodash'
import { store } from '@/main'

const taskLabelPropertiesList = ['system-nazev']
const projectLabelPropertiesList = ['system-nazev']
const resourceLabelPropertiesList = ['system-nazev', 'system-jmeno', 'system-prijmeni']

/**
 * Fce pro generovani labelu pro ukoly
 * @param {Object} task
 * @param {String} emptyLabel
 * @return {String}
 */
export const task = (task, emptyLabel = '[empty label]') => {
    let label = _.chain(_.get(store.getters.currentUser, 'company.settings.gui.labels.tasks', taskLabelPropertiesList))
        .map(pn => _.get(task, `propertyValues.${pn}.value.value`, ''))
        .join(' ')
        .trim()
        .value()
    if (_.size(label) === 0) {
        label = emptyLabel
    }
    return label
}

/**
 * Fce pro generovani labelu pro projekty
 * @param {Object} project
 * @param {String} emptyLabel
 * @return {String}
 */
export const project = (project, emptyLabel = '[empty label]') => {
    let label = _.chain(_.get(store.getters.currentUser, 'company.settings.gui.labels.projects', projectLabelPropertiesList))
        .map(pn => _.get(project, `propertyValues.${pn}.value.value`, ''))
        .join(' ')
        .trim()
        .value()
    if (_.size(label) === 0) {
        label = emptyLabel
    }
    return label
}

/**
 * Fce pro generovani labelu pro zdroje
 * @param {Object} resource
 * @param {String} emptyLabel
 * @return {String}
 */
export const resource = (resource, emptyLabel = '[empty label]') => {
    let label = _.chain(_.get(store.getters.currentUser, 'company.settings.gui.labels.resources', resourceLabelPropertiesList))
        .map(pn => _.get(resource, `propertyValues.${pn}.value.value`, ''))
        .join(' ')
        .trim()
        .value()
    if (_.size(label) === 0) {
        label = emptyLabel
    }
    return label
}

export default {
    task,
    project,
    resource,
}
